import React from 'react';
import {styled} from '@netx/core-components/Theme';
import {CUSTOM_ACTION_COLUMN_LABEL} from '../../locales';
import {CustomActionField} from '../../schema';
import {
	CustomActionEndpoint,
	CustomActionEndpointProps,
} from '../CustomActionEndpoint';

const CustomActionEndpointTargetUrlRoot = styled(CustomActionEndpoint)(
	({theme}) => ({}),
);

export interface CustomActionEndpointTargetUrlProps
	extends CustomActionEndpointProps {}

export const CustomActionEndpointTargetUrlPrimitive = ({
	customActionId,
	changed,
	formFieldOptions,
	...props
}: CustomActionEndpointTargetUrlProps) => {
	return (
		<CustomActionEndpointTargetUrlRoot
			label={CUSTOM_ACTION_COLUMN_LABEL[CustomActionField.targetUrl]}
			name={CustomActionField.targetUrl}
			{...props}
			formFieldOptions={{
				validator: async (value) =>
					// `eventId` is reserved
					value.match(/(\?|&)eventId=/)
						? new Error('invalid url')
						: formFieldOptions?.validator
						? formFieldOptions.validator(value)
						: true,
			}}
		/>
	);
};

export const CustomActionEndpointTargetUrl =
	CustomActionEndpointTargetUrlPrimitive;

export default CustomActionEndpointTargetUrl;
